import { AfterViewInit, Component, OnInit, HostListener, ViewChild, ElementRef } from "@angular/core";
import { HttpClient } from '@angular/common/http';
import { MessageService} from './message.service';
import { Injectable } from '@angular/core';
declare var SockJS;
declare var Stomp;
import { environment } from "../../environments/environment";
import { catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { parse } from "path";
import { stringify } from "querystring";
import { CookieService } from 'ngx-cookie-service';
import { BehaviorSubject } from 'rxjs';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse,
  HttpHeaders
} from '@angular/common/http';
import { SecurityService } from "../_services/security.service";
import { Console, error } from "console";
import { LoginData } from "../_models/loginData";
import { ProjectService } from "../_services/project.service";
import { Router, Event, NavigationStart, NavigationEnd, NavigationError} from '@angular/router';
import { event } from "jquery";
import internal from "stream";
import { MemoryService } from "../_services/memory.service";


declare var $;
declare const window: any;

@Component({
  selector: "app-chat-bot",
  templateUrl: "./chat-bot.component.html",
  styleUrls: ["./chat-bot.component.css"],
})
export class ChatBotComponent implements OnInit, AfterViewInit {
  state: boolean = false;
  endpoint : any;
  endpoint2 : any;
  endpoint3 : any;
  apiUrl : any;
  apiKey : any;
  conversation: any[] = [];
  genAIEnabled: boolean = environment.DISPLAY_GENAI;
  maxResponseTokens = 250;
  subscriptionKey : any;
  firsttimechips: boolean;
  userNameFlag: boolean = true;
  loadingCount: any;
  dashBoardFlag: boolean = true;
  public openApiFlag: boolean = false;
  public onCheckboxChecked: boolean = false;
  public automationsFlag: boolean = true;
  private connectionStatusSubject = new BehaviorSubject<boolean>(false);
  userInput: string = '';
  connectionStatus$ = this.connectionStatusSubject.asObservable();
  public chipsFlag: boolean = true;
  public baseServerUrl = environment.baseUrl;
  currentRoute: string;
  messages : any;
  input;
  flag: boolean = true;
  agentCheck: boolean;
  @ViewChild("chipsHuGO", null) chipsHuGO: ElementRef;
  constructor(private router: Router ,private http : HttpClient, private messageService: MessageService, private cookieService: CookieService, private securityService: SecurityService, private project: ProjectService, private memoryService: MemoryService) {
    this.currentRoute = "";
    this.memoryService.getAgentCheck().subscribe((res)=>
    {
      this.agentCheck = res;
    })
    this.router.events.subscribe((event: Event) => {
        if (event instanceof NavigationStart) {
          this.initializeWebSocketConnection();
          this.connectionStatus$.subscribe(isConnected => {
            if (isConnected) {
              console.log('WebSocket connected. You can now send messages.');
              // Enable input field and send button here
            } else {
              console.log('WebSocket disconnected. Please wait for reconnection.');
              // Disable input field and send button here
            }
          });
          this.loadingCount = 0;
          if(this.cookieService.get('loginSubscriptionData')) {
            this.loginData = JSON.parse(this.cookieService.get('loginSubscriptionData'));
            const headers = new HttpHeaders().set("Authorization", 'Basic ' + this.securityService.base64Encode('Bearer:' + this.loginData.access_token));
          }else {
            this.loginData = "";
          }
          this.userAgent = window.navigator.userAgent;
            setTimeout(() => {
            if(this.loginData != ""){
              this.userCreds = {
                sender: this.userAgent,
                content: "Basic " + this.securityService.base64Encode('Bearer:' + this.loginData.access_token),
                type: this.baseServerUrl
            };
            } else {
              this.userCreds = {
                sender: '',
                content: '',
                type: ''
              };
            }
            this.stompClient.send('/app/chat.sendDetails' , {}, JSON.stringify(this.userCreds));
            var chatMessage = {
              sender: this.baseServerUrl,
              content: "PointBreak",
              type: 'CHAT'
            };
            this.stompClient.send('/app/chat.userInput' , {}, JSON.stringify(chatMessage));
            }, 3500);
            const chatBox = document.querySelector(".chatbox__support");
            if(this.state){
            this.toggleState(chatBox);
            }
        }

        if (event instanceof NavigationEnd) {
            // Hide loading indicator
            this.currentRoute = event.url;          
              if(event.url == "/signout"){
                this.flag = false;
                this.userNameFlag = true;
                this.chipsFlag = true;
                
              }
              if(event.url == "/Dashboard" || event.url == "/project/home"){
                if(this.dashBoardFlag){
                  this.firsttimechips = true;
                  this.chipsFlag = true;
                  this.userNameFlag = true;
                  this.automationsFlag = true;
                  this.initializeWebSocketConnection();
                  this.connectionStatus$.subscribe(isConnected => {
                    if (isConnected) {
                      console.log('WebSocket connected. You can now send messages.');
                      // Enable input field and send button here
                    } else {
                      console.log('WebSocket disconnected. Please wait for reconnection.');
                      // Disable input field and send button here
                    }
                  });
                  const chatBox = document.querySelector(".chatbox__support");
                  if(this.state){
                     this.toggleState(chatBox);
                  }
                  this.removeElementsByClass("message new");
                  this.dashBoardFlag = false;
                }
                var e = document.getElementById("widgetIcon");
                e.style.display = "block";
                e.style.animation = "none";
                e.style.background = "#012B59"
                var f = document.getElementById("closeSvg");
                f.style.fill = "white";
                document.getElementById('hlp').setAttribute( 'src', 'assets/newImages/icons/chatbot.svg' );
              }
              if(event.url == "/login"){
                this.automationsFlag = false;
                this.initializeWebSocketConnection();
                  const chatBox = document.querySelector(".chatbox__support");
                  if(this.state){
                     this.toggleState(chatBox);
                  }
                this.removeElementsByClass("message new");
                this.dashBoardFlag = true;
                var e = document.getElementById("widgetIcon");
                e.style.display = "none";
                e.style.background = "#012B59";
                var f = document.getElementById("closeSvg");
                f.style.fill = "white";
                document.getElementById('hlp').setAttribute( 'src', 'assets/newImages/icons/chatbot.svg' );
                e.style.animation = "bounce2 2s ease infinite";
              }
        }

        if (event instanceof NavigationError) {
        }
    });

  }
  
  public stompClient;
  public msg = [];
  public serverMsg : any;
  public chatbotUser = "";
  public chatbotUserAOAI = "";
  public recordedOutput: any;
  public loginData;
  public userAgent;
  public userCreds;
  public testflag;
  public chatbotInput: string;
  public chatbotResponse: any;

  toggleOpenApi(){
    if(this.openApiFlag){
      this.openApiFlag = false;
      console.log("OpenAPI:-" + this.openApiFlag);
    }else
    {
      this.openApiFlag = true;
      console.log("OpenAPI:-" + this.openApiFlag);
    }
  }

  focusOnInput() {
    setTimeout(() => {
      const inputElement = document.getElementById('MSG') as HTMLInputElement;
      if (inputElement) {
        inputElement.focus();
        inputElement.click();
      }
    }, 300); // Small delay to ensure the chat box is fully opened
  }

  askQuestion3(question: string) {

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+ `${this.apiKey}`
    });
  
    const requestBody = {
      prompt: question
    };
  
    return this.http.post<any>(this.apiUrl, requestBody, { headers: headers }).pipe(
      catchError(error => {
        console.error('Error fetching response from QnA Maker:', error);
        return of({ answers: [] }); // Return an empty response in case of an error
      })
    );
  }
  
  
  onUserInput3(chatbotmsg: string) {
    console.log("LanguageStudio");
    this.askQuestion3(chatbotmsg).subscribe(
      (response: any) => {
        console.log(response);
        this.chatbotResponse = response.choices[0]?.text;
        // console.log(response);
      },
      (error) => {
        console.error('Error fetching response from QnA Maker:', error);
      }
    );
  }

  askQuestion(question: string) {

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Ocp-apim-subscription-key': `${this.subscriptionKey}`
    });
  
    const body = {
      question: question
    };
  
    return this.http.post<any>(this.endpoint2, body, { headers: headers }).pipe(
      catchError(error => {
        console.error('Error fetching response from QnA Maker:', error);
        return of({ answers: [] }); // Return an empty response in case of an error
      })
    );
  }
  
  
  onUserInput(chatbotmsg: string) {
    console.log("LanguageStudio");
    this.askQuestion(chatbotmsg).subscribe(
      (response: any) => {
        // Extract the answer from the response
        this.chatbotResponse = response.answers[0]?.answer;
        console.log(response);
      },
      (error) => {
        console.error('Error fetching response from QnA Maker:', error);
      }
    );
  }

  onCheckboxChange(event: any) {
    this.onCheckboxChecked = event.target.checked;
    if (event.target.checked) {
      console.log('Checkbox is checked');
      var z = document.getElementById("lblname");
      z.style.marginLeft = "16px";
      z.style.color = "white";
      var x = document.getElementById("Genimg");
      x.style.display = "block";
      var y = document.getElementById("lblimg");
      y.style.width = "24rem";
      this.toggleOpenApi();
    } else {
      var z = document.getElementById("lblname");
      z.style.marginLeft = "40px";
      z.style.color = "#103b66";
      var x = document.getElementById("Genimg");
      x.style.display = "none";
      var y = document.getElementById("lblimg");
      y.style.width = "18rem";
      console.log('Checkbox is unchecked');
      this.toggleOpenApi();
    }
    this.updateChipsDisplay();
  }

  updateChipsDisplay() {
    if(this.firsttimechips) {
    this.removeChips();
    if (this.onCheckboxChecked) {
      // Display 3 chips for Generative AI on
      $('<div id="chipB" class="message message-chipsbrowsing new">Just browsing!</div>').appendTo($('.mCSB_container')).addClass('new');
      $('<div id="chipQ" class="message message-chipsquestion new">Know more about HuLoop</div>').appendTo($('.mCSB_container')).addClass('new');
      $('<div id="chipC" class="message message-chipsclose2 new">HuLoop Functions and Commands</div>').appendTo($('.mCSB_container')).addClass('new');
      this.automationsFlag = false;
      this.focusOnInput();
    } else {
      // Display 4 chips for Generative AI off
      $('<div id="chipB" class="message message-chipsbrowsing new">Just browsing!</div>').appendTo($('.mCSB_container')).addClass('new');
      $('<div id="chipQ" class="message message-chipsquestion new">Know more about HuLoop</div>').appendTo($('.mCSB_container')).addClass('new');
      $('<div id="chipH" class="message message-chipsHuLoop new">Automation Operations</div>').appendTo($('.mCSB_container')).addClass('new');
      $('<div id="chipC" class="message message-chipsclose new">HuLoop Functions</div>').appendTo($('.mCSB_container')).addClass('new');
      this.automationsFlag = true;
      this.focusOnInput();
    }
  }
  }

  initializeWebSocketConnection() {
    if(this.cookieService.get('loginSubscriptionData')) {
      this.loginData = JSON.parse(this.cookieService.get('loginSubscriptionData'));
      const headers = new HttpHeaders().set("Authorization", 'Basic ' + this.securityService.base64Encode('Bearer:' + this.loginData.access_token));
    }else {
      this.loginData = "";
    }
    this.userAgent = window.navigator.userAgent;
    const serverUrl = environment.app_url;
    const ws = new SockJS(serverUrl);
    this.stompClient = Stomp.over(ws);
    const that = this;
    this.stompClient.connect({}, 
      (frame) => {
        console.log('Connected: ' + frame);
        this.connectionStatusSubject.next(true);
        
        that.stompClient.subscribe('/user/queue/chat.sendMessage', (message) => {
          if (message.body) {
            var parsedData = JSON.parse(message.body);
            console.log(parsedData.content);
            that.chatbotResponse = parsedData.content;
          }
        });
        that.stompClient.subscribe('/user/queue/chat.sendDetails', (message) => {
          if (message.body) {
            var parsedData = JSON.parse(message.body);
            that.chatbotUser = parsedData.content;
          }
        });
        that.stompClient.subscribe('/user/queue/chat.languageStudio', (message) => {
          if (message.body) {
            var parsedData = JSON.parse(message.body);
            that.chatbotResponse = parsedData.content;
            that.chatbotResponse = that.chatbotResponse.replace("?", "");
          }
        });
        that.stompClient.subscribe('/user/queue/chat.azureOpenAI', (message) => {
          if (message.body) {
            var parsedData = JSON.parse(message.body);
            console.log(parsedData.content);
            that.chatbotResponse = parsedData.content;
          }
        });
        that.stompClient.subscribe('/user/queue/chat.azureCognitiveSearch', (message) => {
          if (message.body) {
            var parsedData = JSON.parse(message.body);
            console.log(parsedData.content);
            that.chatbotResponse = parsedData.content;
          }
        });
        that.stompClient.subscribe('/user/queue/chat.luis', (message) => {
          if (message.body) {
            var parsedData = JSON.parse(message.body);
            console.log(parsedData.content);
          }
        });
        that.stompClient.subscribe('/user/queue/chat.userInput', (message) => {
          if (message.body) {
            var parsedData = JSON.parse(message.body);
            console.log(parsedData.content);
            that.chatbotResponse = parsedData.content;
          }
        });
      }, 
      (error) => {
        console.error('Connection error: ' + error);
        this.connectionStatusSubject.next(false);
      }
    );
    
  }

  sendMessage() {
    if($('#chipGet').length || $('#chipB').length) {
      this.removeChips();
    }
    let message : any;
    message  = document.getElementById("mymsg")!
    var chatMessage = {
      sender: this.baseServerUrl,
      content: message.MSG.value,
      type: 'CHAT'
    };
    if(this.loginData != ""){
      this.userCreds = {
        sender: this.userAgent,
        content: "Basic " + this.securityService.base64Encode('Bearer:' + this.loginData.access_token),
        type: this.baseServerUrl
    };
    } else {
      this.userCreds = {
        sender: '',
        content: '',
        type: this.baseServerUrl
      };
    }
    if(message.MSG.value == "") {
      message = this.recordedOutput;
      var chatMessage = {
        sender: this.baseServerUrl,
        content: message,
        type: 'CHAT'
      };
    }
    if (message.MSG.value) {
      this.messageService.sendMessage(message.MSG.value);
      this.input = '';
    }
    if (this.connectionStatusSubject.getValue() && this.userInput.trim() !== '') {
      // Your existing send message logic here
      console.log('Sending message:', this.userInput);
      // Clear the input after sending
      this.userInput = '';
    }
    if(this.openApiFlag == false){
    console.log("LANGUAGESTUDIO2");
    // this.stompClient.send('/app/chat.luis' , {}, JSON.stringify(chatMessage));
    this.stompClient.send('/app/chat.sendDetails' , {}, JSON.stringify(this.userCreds));
    this.stompClient.send('/app/chat.userInput' , {}, JSON.stringify(chatMessage));
    this.chatbotInput = message.MSG.value;
    }else {
    console.log("Testing");
    // this.stompClient.send('/app/chat.sendMessage' , {}, JSON.stringify(chatMessage));
    // this.stompClient.send('/app/chat.azureOpenAI' , {}, JSON.stringify(chatMessage));
    this.stompClient.send('/app/chat.azureCognitiveSearch' , {}, JSON.stringify(chatMessage));
    this.chatbotInput = message.MSG.value;
    }
  }

  ngAfterViewInit(): void {
    this.messages = $(".messages-content");

    const openButton: any = document.querySelector(".chatbox__button");
    const chatBox = document.querySelector(".chatbox__support");

    openButton.addEventListener("click", () => this.toggleState(chatBox));

    let  recognition;
    //speech reco
    try {
      const SpeechRecognition =  window.SpeechRecognition || window.webkitSpeechRecognition;
      recognition = new SpeechRecognition();
    } catch (e) {
      console.error(e);
      $(".no-browser-support").show();
    }

    $("#start-record-btn").on("click", function (e) {
      let mic = document.getElementById("start-record-btn");
      mic.style.color = "#f30000";
      recognition.start();
      recognition.addEventListener('end', () => {
        let mic = document.getElementById("start-record-btn");
        mic.style.color = "#878fac";
      });
      
    });

    // $("#apibutton").on("click", function (e) {
    //   this.getDataFromAPI();
    // });

    recognition.onresult = (event) => {
      let  speechToText : string = event.results[0][0].transcript;
      let message = document.getElementById("MSG")!
      if(speechToText.includes("holook") || speechToText.includes("loop") || speechToText.includes("Hula Hoop") || speechToText.includes("holic") || speechToText.includes("hold up") || speechToText.includes("holup") || speechToText.includes("holope") || speechToText.includes("holo") || speechToText.includes("full open") || speechToText.includes("hulu") || speechToText.includes("hulop") || speechToText.includes("who loop") || speechToText.includes("hulup")){
        speechToText = speechToText.replace("holook","HuLoop");
        speechToText = speechToText.replace("hold up","HuLoop");
        speechToText = speechToText.replace("Hula Hoop","HuLoop");
        speechToText = speechToText.replace("holic","HuLoop");
        speechToText = speechToText.replace("full open","HuLoop");
        speechToText = speechToText.replace("holup","HuLoop");
        speechToText = speechToText.replace("holope","HuLoop");
        speechToText = speechToText.replace("holo","HuLoop");
        speechToText = speechToText.replace("hulu","HuLoop");
        speechToText = speechToText.replace("loop","HuLoop");
        speechToText = speechToText.replace("who loop","HuLoop");
        speechToText = speechToText.replace("hulop","HuLoop");
        speechToText = speechToText.replace("hulup","HuLoop");
      }
      if(speechToText.includes("unscape") || speechToText.includes("inscape") || speechToText.includes("UN skip") || speechToText.includes("on skip")) {
        speechToText = speechToText.replace("unscape","unskip");  
        speechToText = speechToText.replace("inscape","unskip"); 
        speechToText = speechToText.replace("UN skip","unskip");
        speechToText = speechToText.replace("on skip","unskip");
      }
      if(speechToText.includes("on check") || speechToText.includes("and check")) {
        speechToText = speechToText.replace("on check","uncheck");  
        speechToText = speechToText.replace("and check","uncheck"); 
      }
      if(speechToText.includes("post grass SQL") || speechToText.includes("post grey SQL") || speechToText.includes("post grace SQL") || speechToText.includes("post gray SQL")) {
        speechToText = speechToText.replace("post grace SQL","PostgreSQL");  
        speechToText = speechToText.replace("post grass SQL","PostgreSQL"); 
        speechToText = speechToText.replace("post grey SQL","PostgreSQL");  
        speechToText = speechToText.replace("post gray SQL","PostgreSQL"); 
      }
      if(speechToText.includes("Aligarh UP") || speechToText.includes("allygrow") || speechToText.includes("Aligarh") || speechToText.includes("regrow")) {
        speechToText = speechToText.replace("Aligarh UP","Allegro");  
        speechToText = speechToText.replace("allygrow","Allegro"); 
        speechToText = speechToText.replace("Aligarh","Allegro");  
        speechToText = speechToText.replace("regrow","Allegro"); 
      }
      if(speechToText.includes("agriya") || speechToText.includes("a grahan") || speechToText.includes("Aligarh") || speechToText.includes("regrow")) {
        speechToText = speechToText.replace("agriya","AgreeYa");  
        speechToText = speechToText.replace("a grahan","AgreeYa"); 
        speechToText = speechToText.replace("Aligarh","Allegro");  
        speechToText = speechToText.replace("regrow","Allegro"); 
      }
      if(speechToText.includes("plus")) {
        speechToText = speechToText.replace("plus","+");  
      }
      if(speechToText.includes("sub menu")) {
        speechToText = speechToText.replace("sub menu","submenu");  
      }
      if(speechToText.includes("no SQL")) {
        speechToText = speechToText.replace("no SQL","noSQL");  
      }
      if(speechToText.includes("couchbase SQL")) {
        speechToText = speechToText.replace("couchbase SQL","CouchbaseSQL");  
      }
      message['value'] = speechToText;
      let mic = document.getElementById("start-record-btn");
      mic.style.color = "#878fac";
      this.insertMessage()
      this.sendMessage();
    }


    document.getElementById("mymsg")!.onsubmit = (e)=>{
      e.preventDefault() 
      this.insertMessage();
      // this.serverMessage("hello");
      // speechSynthesis.speak( new SpeechSynthesisUtterance("hello"))
    }
  }

  ngOnInit(): void {
  }

  toggleState(chatbox) {
    if(this.userNameFlag){
    this.chipsFlag = true;
    const elements = document.getElementsByClassName("message new");
    while(elements.length > 0){
        elements[0].parentNode.removeChild(elements[0]);
    }
    setTimeout(() => {
      this.serverMessage("Greetings " + this.chatbotUser + "! How can I assist?", this.chipsFlag);
    }, 3000);
    this.userNameFlag = false;
    }
    if(this.flag){
    this.state = !this.state;
    // show or hides the box
    if (this.state) {
      chatbox.classList.add("chatbox--active");
      var x = document.getElementById("hlp");
      x.classList.toggle("hidden");
      var z = document.getElementById("closeIcon");
      z.style.visibility = "visible";
      var y = document.getElementById("closeIcon");
      y.classList.toggle("rotate-fade");
      var abc = document.getElementById("chatboxt");
      abc.style.height = "385px";
      abc.style.width = "370px";
      var e = document.getElementById("widgetIcon");
      e.style.animation = "none";

    } else {
      chatbox.classList.remove("chatbox--active");
      var x = document.getElementById("hlp");
      x.classList.toggle("hidden");
      var y = document.getElementById("closeIcon");
      y.classList.toggle("rotate-fade");
      var z = document.getElementById("closeIcon");
      z.style.visibility = "hidden";
      if(this.loginData == ""){
      var e = document.getElementById("widgetIcon");
      e.style.animation = "bounce2 2s ease infinite";
      }
      setTimeout(() => {
        var abc = document.getElementById("chatboxt");
        abc.style.height = "0px";
        abc.style.width = "0px";
      }, 500);
    }
  }
  }

  removeElementsByClass(className){
    const elements = document.getElementsByClassName(className);
    while(elements.length > 0){
        elements[0].parentNode.removeChild(elements[0]);
    }
    if(this.flag){
    this.serverMessage("Greetings "+ this.chatbotUser + "! How can I assist?", this.chipsFlag);
    }
    else{
      this.flag = true;
    }
  }

  removeChips(){
    let chipClasses: string[] = ['message message-chipsHuLoop new', 'message message-chipsbrowsing new', 'message message-chipsquestion new', 
    'message message-chipsclose new','message message-chipsclose2 new', 'message message-chipsCRUDGET new', 'message message-chipsCRUDCREATE new', 'message message-chipsCRUDDELETE new', 'message message-chipsCRUDUPDATE new']; 
    for( var i = 0; i < chipClasses.length ; i++ ){
    const elements = document.getElementsByClassName(chipClasses[i]);
    while(elements.length > 0){
        elements[0].parentNode.removeChild(elements[0]);
    }
  }
  }

   listendom(no){
    document.getElementById("MSG")!['value']= no.innerHTML;
    this.insertMessage();
  }
  
  
   updateScrollbar() {
  }
  
  
  
   insertMessage() {
    this.firsttimechips = false;
    let msg = $('.message-input').val();
    if ($.trim(msg) == '') {
      return false;
    }
    $('<div class="message message-personal">' + msg + '</div>').appendTo($('.mCSB_container')).addClass('new');
    var elem = document.getElementById("hlp1");
    elem.scrollTop = elem.scrollHeight;
    this.recordedOutput = msg;
    this.sendMessage();
    this.fetchmsg();
    $('.message-input').val(null);
    $('<div id="loadingcontainer"><div id="loading-bubble" style="min-width: 55px; min-height: 30px;"><div class="spinnerbot"><div class="bounce1"></div><div class="bounce2"></div><div class="bounce3"></div></div></div></div>').appendTo($('.mCSB_container'));

  }
  

   serverMessage(response2, chipsflag) {
    
    if(response2 == "crudChips"){
      setTimeout(() => {
        $('<div id="chipGet" class="message message-chipsCRUDGET new">' + "Get automation details" + '</div>').appendTo($('.mCSB_container')).addClass('new');
        $('<div id="chipCreate" class="message message-chipsCRUDCREATE new">' + "Create automation" + '</div>').appendTo($('.mCSB_container')).addClass('new');
        $('<div id="chipDelete" class="message message-chipsCRUDDELETE new">' + "Delete an automation" + '</div>').appendTo($('.mCSB_container')).addClass('new');
        $('<div id="chipUpdate" class="message message-chipsCRUDUPDATE new">' + "Update an automation" + '</div>').appendTo($('.mCSB_container')).addClass('new');
        this.focusOnInput();
      }, 10000);
      this.focusOnInput();
        return false;
    }
    let that = this;
    console.log("THIS IS THE LOADING TING" + that.loadingCount);
    if ($('.message-input').val() != '') {
      return false;
    }
    var elem = document.getElementById("hlp1");
    elem.scrollTop = elem.scrollHeight;
    this.updateScrollbar();
    
    
    setTimeout(function() {
      $('#loadingcontainer').remove();
      $('<div class="message new">' + response2 + '</div>').appendTo($('.mCSB_container')).addClass('new');
      if(chipsflag) {
        if(that.automationsFlag){
        $('<div id="chipB" class="message message-chipsbrowsing new">' + "Just browsing!" + '</div>').appendTo($('.mCSB_container')).addClass('new');
        $('<div id="chipQ" class="message message-chipsquestion new">' + "Know more about HuLoop" + '</div>').appendTo($('.mCSB_container')).addClass('new');
        $('<div id="chipH" #chipsHuGO class="message message-chipsHuLoop new">' + "Automation Operations" + '</div>').appendTo($('.mCSB_container')).addClass('new');
        $('<div id="chipC" class="message message-chipsclose new">' + "HuLoop Functions" + '</div>').appendTo($('.mCSB_container')).addClass('new');
        }else{
          $('<div id="chipB" class="message message-chipsbrowsing new">' + "Just browsing!" + '</div>').appendTo($('.mCSB_container')).addClass('new');
          $('<div id="chipQ" class="message message-chipsquestion new">' + "Know more about HuLoop" + '</div>').appendTo($('.mCSB_container')).addClass('new');
          $('<div id="chipC" class="message message-chipsclose2 new">' + "HuLoop Functions and Commands" + '</div>').appendTo($('.mCSB_container')).addClass('new');
        }
        chipsflag = false;
        that.chipsFlag = false;
      }
      var elem = document.getElementById("hlp1");
      elem.scrollTop = elem.scrollHeight;
      that.updateScrollbar();
      that.focusOnInput();
    }, 100 + (Math.random() * 20) * 100);
  }
  

  @HostListener('window:click', ['$event'])
  onWindowScroll($event) {
    let that = this;
    var chipF: any;
    // console.log("This is the automation flag" + that.automationsFlag)
    if(that.automationsFlag){
      chipF = $('#chipH').length;
    }else {
      chipF = $('#chipB').length;
    }
    // console.log("This is the chip flag" + chipF)
    if(chipF){
    if(that.automationsFlag){
    document.getElementById('chipH').onclick = function(this: HTMLElement) { 
      if(that.loginData != ""){
        that.removeChips();
        let message = document.getElementById("MSG")!
        message['value'] = "Automation Operations";
        that.insertMessage();
        that.serverMessage("crudChips", that.chipsFlag);
      }
      else{
        that.removeChips();
        let message = document.getElementById("MSG")!
        message['value'] = "Automation Operations";
        that.insertMessage();
      }
    };
    }
    document.getElementById('chipQ').onclick = function(this: HTMLElement) { 
      that.removeChips();
      let message = document.getElementById("MSG")!
      message['value'] = "What is HuLoop";
      that.insertMessage();
    };
    document.getElementById('chipB').onclick = function(this: HTMLElement) { 
        that.removeChips();
    };
    document.getElementById('chipC').onclick = function(this: HTMLElement) { 
      that.removeChips();
      let message = document.getElementById("MSG")!
      message['value'] = "HuLoop Functions and Commands";
      that.insertMessage();
    };
  }
    if($('#chipGet').length) {
    document.getElementById('chipGet').onclick = function(this: HTMLElement) { 
      that.removeChips();
      let message = document.getElementById("MSG")!
      message['value'] = "Get automation details";
      that.insertMessage();
    };
    document.getElementById('chipCreate').onclick = function(this: HTMLElement) {
      that.removeChips();
      let message = document.getElementById("MSG")!
      message['value'] = "Create an automation";
      that.insertMessage();
    };
    document.getElementById('chipDelete').onclick = function(this: HTMLElement) { 
      that.removeChips();
      let message = document.getElementById("MSG")!
      message['value'] = "Delete an automation";
      that.insertMessage();
    };
    document.getElementById('chipUpdate').onclick = function(this: HTMLElement) {
      that.removeChips();
      let message = document.getElementById("MSG")!
      message['value'] = "Update an automation";
      that.insertMessage();
    };
  }
  }
  
  
  simulateDoubleClick(element: HTMLElement) {
    const event = new MouseEvent('dblclick', {
      'view': window,
      'bubbles': true,
      'cancelable': true
    });
    element.dispatchEvent(event);
  }

  
   fetchmsg(){
  
    setTimeout(() => {
      if(this.openApiFlag == false){
      // this.serverMsg = this.serverMsg.replace(/["']/g, "");
      if(this.chatbotResponse == "Your automation has been successfully deleted" || this.chatbotResponse == "Your automation has been successfully created" || this.chatbotResponse == "Your automation has been successfully updated"){
        if(this.agentCheck)
        {
          this.memoryService.setAllProjectsData([]);
        }
        else
        {
          localStorage.removeItem('allProjects');
        }

        this.project.sendProjectData("HugoChatbot");
      }
      if(this.chatbotResponse == "undefined"){
        this.chatbotResponse == "There was an issue connecting to the server. Kindly refresh and try again."
      }
      console.log(this.chatbotResponse);
      this.serverMessage(this.chatbotResponse, this.chipsFlag);
    }else{
      console.log(this.chatbotResponse);
      this.serverMessage(this.chatbotResponse, this.chipsFlag);
      // console.log(this.serverMsg);
      // this.serverMessage(this.serverMsg, this.chipsFlag);
    }
    }, 8000);
  }

}


